export const PHONE_MASK = [
  '+',
  '7',
  ' ',
  '(',
  /[1-9]/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
];

export const SNILS_MASK = [
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
];

export const GENDERS = [
  {
    text: 'Не выбрано',
    value: 0,
  },
  {
    text: 'Мужской',
    value: 'M',
  },
  {
    text: 'Женский',
    value: 'W',
  },
];

export const FORM_SUCCESS_MESSAGE: string = 'Изменения сохранены!';
export const FORM_ERROR_MESSAGE: string = 'Изменения не сохранены!';
export const SNILS_ERROR_EMPTY: string = 'Пожалуйста, введите ваш СНИЛС';
export const SNILS_ERROR_FORMAT: string = 'Неверный формат';
export const EMAIL_FORMAT_ERROR: string = 'Укажите правильный адрес e-mail';
export const EMAIL_REQUIRED_ERROR: string = 'Обязательное поле';



// WEBPACK FOOTER //
// ./src/pages/profile/views/general/consts.ts